module.exports = __webpack_public_path__ + "img/typehoon32.3c63fb90.png";